(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wg-card-info"] && !Shopify.designMode) return;
  try {
    (() => {
    // Show a different real color mockup on neighbouring cards so the grid is not all one color
    const vary = () => {
      const cards = [...document.querySelectorAll('product-card:has(.wg-ci)')];
      cards.forEach((card, i) => {
        if (card.dataset.wgVary) return;
        const s = card.querySelector('slideshow-component');
        if (!s || typeof s.select !== 'function') return;
        const n = parseInt(s.dataset.genericMediaSize || '0', 10);
        card.dataset.wgVary = '1';
        if (n < 5) return;
        const k = i % 3;
        if (k === 0) return;
        s.setAttribute('initial-slide', String(k));
        try { s.select(k, undefined, { animate: false }); } catch (e) {}
      });
    };
    let t = 0;
    const kick = () => { clearTimeout(t); t = setTimeout(vary, 200); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kick); else kick();
    customElements.whenDefined('slideshow-component').then(kick);
    new MutationObserver(kick).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
